import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

import { FileUpload, UploadStatus } from './file-upload.model';

@Component({
  selector: 'cp-file-progress',
  templateUrl: './file-progress.component.html',
  styleUrls: ['./file-progress.component.less']
})
export class FileProgressComponent {
  @Input()
  file: FileUpload;

  @Output()
  remove = new EventEmitter<FileUpload>();

  @HostBinding('class.mod-error')
  get hasError() {
    return this.file && this.hasFailed || this.isDuplicate;
  }

  @HostBinding('class.mod-complete')
  get isComplete() {
    return this.file && this.file.status === UploadStatus.Complete;
  }

  get isReady() {
    return this.file.status === UploadStatus.Ready;
  }

  get hasFailed() {
    return this.file.status === UploadStatus.Failed;
  }

  get isDuplicate() {
    return this.file.status === UploadStatus.Duplicate;
  }

  get isUploading() {
    return this.file.status === UploadStatus.Uploading;
  }

  get progress() {
    switch (this.file.status) {
      case UploadStatus.Uploading: return this.file.progress;
      case UploadStatus.Complete: return 100;
      default: return 0;
    }
  }

  onRemove(file: FileUpload, $event: MouseEvent) {
    $event.stopPropagation();
    this.remove.emit(file);
  }
}
